import { CommonUtil } from '@utils/common/common';
import { IAlertList, alertFilterType, IAlertHistory } from '@models/manager/account/accountModel';
import moment from 'moment';
import { gameProviderTypes } from '@configs/layout';

export class AlertOption {
  alertList(responseData, enableCallback, historyCallback) {
    const _data: IAlertList[] = CommonUtil.getArrayByValidate(responseData);
    const columns = [
      {
        name: 'Alert Name',
        selector: (row) => row.alertName,
        cell: (row) => row.alertName,
        sortable: true,
        minWidth: '250px',
      },
      {
        name: 'Create Date',
        selector: (row) => row.createDate,
        cell: (row) => moment(row.createDate).format('YYYY-MM-DD'),
        sortable: true,
      },
      {
        name: 'Last Send Date',
        selector: (row) => row.lastSendDate,
        cell: (row) => moment(row.lastSendDate).format('YYYY-MM-DD'),
        sortable: true,
      },
      {
        name: 'Enable',
        selector: (row) => row.enable,
        cell: (row) => (
          <div>
            <input
              type="checkbox"
              checked={row.enable}
              className="ipt-check enable"
              id={`checked-${row.id}`}
              onChange={() => enableCallback(row)}
            />
            <label htmlFor={`checked-${row.id}`}>
              <span className="blind">선택</span>
            </label>
          </div>
        ),
        sortable: true,
      },
      {
        name: 'Send History',
        // selector: row =>
        cell: (row) => (
          <div>
            <button type="button" className="btn-ico-single send-history" onClick={(row) => historyCallback(row)}>
              <span className="blind">Send History</span>
            </button>
          </div>
        ),
        sortable: false,
      },
    ];

    return {
      data: _data,
      columns,
    };
  }

  alertHistory(responseData, filterObj?: alertFilterType) {
    const _data: IAlertHistory[] = CommonUtil.getArrayByValidate(responseData);
    const columns = [
      {
        name: 'Alert Names',
        selector: (row) => row.alertName,
        cell: (row) => row.alertName,
        sortable: true,
        minWidth: '150px',
      },
      {
        name: 'Alert Class',
        selector: (row) => row.alertClass,
        cell: (row) => (
          <>
            {row.alertClass.map((item, index) => {
              if (index === 0) {
                return item;
              } else {
                return `/ ${item}`;
              }
            })}
          </>
        ),
        sortable: false,
        minWidth: '150px',
      },
      {
        name: 'Type',
        selector: (row) => row.alertType,
        cell: (row) => row.alertType.substr(0, 1).toUpperCase() + row.alertType.substr(1),
        sortable: true,
        maxWidth: '80px',
      },
      {
        name: 'Email',
        selector: (row) => row.email,
        cell: (row) => row.email,
        sortable: true,
        minWidth: '230px',
      },
      {
        name: 'Store',
        selector: (row) => row.store,
        cell: (row) => (
          <div>
            {row.store === gameProviderTypes.GooglePlayStore ? (
              <p className="btn-ico-single android-s">
                <span className="blind">Google Store</span>
              </p>
            ) : (
              <p className="btn-ico-single app-s">
                <span className="blind">App Store</span>
              </p>
            )}
          </div>
        ),
        sortable: true,
        maxWidth: '40px',
      },
      {
        name: 'Send Date',
        selector: (row) => row.sendDate,
        cell: (row) => moment(row.sendDate).format('YYYY-MM-DD'),
        sortable: true,
        minWidth: '120px',
      },
    ];

    let data = _data;
    // select 선택에 대한 필터링 처리
    if (filterObj) {
      const { alertClass, alertType, alertStore } = filterObj;
      // alertClass
      if (alertClass) {
        data = data.filter((item) => item.alertClass.includes(alertClass));
      }
      // alertType
      if (alertType) {
        data = data.filter((item) => item.alertType === alertType);
      }
      // alertStore
      if (alertStore) {
        data = data.filter((item) => item.store === alertStore);
      }
    }

    return {
      data,
      columns,
    };
  }
}
